<template>
    <div v-if="isInFuture && !isInformativeOnly">
        <div :class="['fw-bold text-capitalize', styles.color]"
             v-if="model && model.type !== planTypes.APPOINTMENT">
            <button class="btn btn-sm btn-success"
                    :disabled="statusApproved" @click.stop="approveOrReject('approve')">
            <span v-if="statusApproved">
                <i class="fi fi-rr-time-check"> </i> {{ trans('general.component.notifications.accepted') }}
            </span>
                <span v-if="!statusApproved">
                {{ trans('general.defaults.accept') }}
            </span>
            </button>
            <button class="btn btn-sm btn-danger" :disabled="statusRejected"
                    @click.stop="approveOrReject('reject')">
            <span v-if="statusRejected"><i class="fi fi-rr-time-delete"> </i>
                {{ trans('general.component.notifications.rejected') }}
            </span>
                <span v-if="!statusRejected">
                  {{ trans('general.defaults.reject') }}
            </span>
            </button>
        </div>

        <div v-if="model && model.type === planTypes.APPOINTMENT && !model.user_status"
             :class="['fw-bold text-capitalize', styles.color]">
            <button class="btn btn-sm btn-open btn-secondary " @click.stop="selectAppointment()">
                <i class="fi fi-rr-time-add"> </i> {{ trans('general.defaults.select') }}
            </button>
        </div>
        <div v-if="model && model.type === planTypes.APPOINTMENT && model.user_status"
             :class="['fw-bold text-capitalize', styles.color]">
            <button class="btn btn-sm btn-danger" @click.stop="cancelAppointment()">
                <i class="fi fi-rr-time-delete "></i> {{ trans('general.defaults.cancel') }}
            </button>
        </div>
    </div>
</template>

<script>
import {PLAN_TYPES} from "../../services/Defaults";
import moment from "moment"
import {eventBus} from "../../services/EventBus";

export default {
    name: "PlanActionButtons",
    props: {
        plan: Object,
        notificationId: Number|String
    },
    data() {
        return {
            planTypes: PLAN_TYPES,
            styles: {background: 'bg-light-pink', color: 'text-pink', icon: 'fi-rr-calendar'},
            model: this.plan
        }
    },
    created() {
        eventBus.$on('eventDataChanged', (data) => {
            if (data.id === this.model.id) {
                this.model = data;
            }
        });
    },
    computed: {
        isInFuture() {
            return moment(this.model?.start).isSameOrAfter(moment(), 'hour');
        },
        isInformativeOnly() {
           return !this.model?.end;
        },
        statusApproved() {
            if (this.model.user_status) {
                return this.model.user_status.approved_at
            }
            return this.model.approved_at
        },
        statusRejected() {
            if (this.model.user_status) {
                return this.model.user_status.rejected_at
            }
            return this.model.rejected_at
        }
    },
    methods: {
        approveOrReject(type) {
            const data = {type};

            if (this.notificationId) {
                data.notification_id = this.notificationId
            }

            axios.post(`/plans/${this.model.id}/approval`, data)
                .then((response) => {
                    eventBus.$emit('eventDataChanged', response.data);

                    this.$emit('status-change',  response.data)
                });
        },
        selectAppointment() {
            axios.post(`/user-plans/select-appointment`, {id: this.model.id})
                .then((response) => {
                    this.$emit('appointment-selected',  response.data)
                });
        },
        cancelAppointment() {
            axios.post(`/user-plans/cancel-appointment`, {id: this.model.id})
                .then((response) => {
                  this.$emit('appointment-cancelled',  response.data)
                });
        }
    },
}
</script>
